<template>
    <div id="self-serve-loading-screen">
        <loading-overlay
            :active.sync="displayLoader"
            :is-full-page="false"
            loader="dots"
            color="#1A74DB"
            height="45"
            width="100%"
            opacity="0">
        </loading-overlay>
        <div class="loading-text loading-title">
            <span>Hold on tight</span>
        </div>
        <div class="loading-text loading-body">
            <span>
                We are taking a few seconds to <br/>assemble your shopping experience.<br/><br/>
                <template v-if="smallFleetMessaging">Want to shop later? Check your email inbox <br/>for a link to return to the webstore.</template>
            </span>
            
        </div>
    </div>
</template>

<script>
export default {
    props: {
        smallFleetMessaging: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    computed: {
        displayLoader() {
            return true;
        }
    },
}
</script>

<style scoped>
.vld-overlay {
    top: 321px;
    position: absolute;
    align-items: normal !important;
}

.loading-text {
    display: flex;
    position: absolute;
    left: 0;
    right: 0;
    align-items: center;
    justify-content: center;
}

.loading-title {
    top: 401px;
    font-family: "Inter", sans-serif;
    font-style: normal;
    font-weight: 600;
    font-size: 28px;
    line-height: 115%;
    text-align: center;
    color: #00263E;
}

.loading-body {
    top: 453px !important;
    font-family: "Inter", sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 115%;
    text-align: center;
    color: #00263E;
}
</style>